import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { editFormSettings } from '../../../store/actions/formActions';
import { Button, Form, Input, message } from 'antd';

const PixelModal = ({ form }) => {
  const [loading, setLoading] = useState(false);
  const currentAnalyticsId = form.integrations?.pixelAnalytics?.analyticsId;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  async function handleFinish(values) {
    try {
      setLoading(true);
      const event = await dispatch(
        editFormSettings(form.id, {
          whatsappNumber: form.whatsappNumber, // To jump validation
          integrations: {
            ...(form.integrations || {}),
            pixelAnalytics: {
              analyticsId: values.analyticsId.toString(),
            },
          },
        }),
      );
      if (event && event.type === 'EDIT_FORM_FAIL') {
        throw Error();
      } else {
        message.success(t('formSettings.updateSuccess'), 2);
      }
    } catch (e) {
      message.error(t('formSettings.updateFail'), 2);
    } finally {
      setLoading(false);
    }
  }
  return (
    <div className="integration-card-content pixel-analytics-card-content">
      <Form
        layout="vertical"
        onFinish={handleFinish}
        initialValues={{
          analyticsId: currentAnalyticsId,
        }}
      >
        <Form.Item label={t('formSettings.pixelAnalyticsLabel')} name="analyticsId">
          <Input placeholder="Pixel Id" />
        </Form.Item>
        <Button type="primary" htmlType="submit" loading={loading} disabled={loading}>
          {currentAnalyticsId ? t('formSettings.updateButton') : t('formSettings.addButton')}
        </Button>
      </Form>
    </div>
  );
};

export default PixelModal;
